export default "__VITE_ASSET__5422YYSv__"